<script>
import Multiselect from 'vue-multiselect'
import FormAudioPlay from '@components/skills-card-form-audio-play'

import FormSpeechSynthesis from '@components/skills-card-form-speech-synthesis'
import FormAudioTranscription from '@components/skills-card-form-audio-transcription'
import FormSetVariables from '@components/skills-card-form-set-variables'
import FormMessageSend from '@components/skills-card-form-message-send'
import FormHTTPRequest from '@components/skills-card-form-http-request'
import FormAIRequest from '@components/skills-card-form-ai-request'
import FormEventWait from '@components/skills-card-form-event-wait'
import FormCondition from '@components/skills-card-form-condition'
import FormIntent from '@components/skills-card-form-intent'
import FormGoTo from '@components/skills-card-form-goto'
import FormDigitalInput from '@components/skills-card-form-digital-input'
import FormCallRedirect from '@components/skills-card-form-call-redirect'
import FormAudioRecord from '@components/skills-card-form-audio-record'
import FormCall from '@components/skills-card-form-call'


export default {

    components: {
        Multiselect, FormAudioPlay, FormSpeechSynthesis, FormAudioTranscription,
        FormSetVariables, FormHTTPRequest, FormCondition, FormIntent,
        FormAudioRecord, FormCall, FormAIRequest, FormMessageSend, FormEventWait, FormCallRedirect, FormGoTo, FormDigitalInput
    },

    props: {
        params: { type: Object },
        type: {type: String},
        targetPath: {type: Object, required: false},
        blockId: {type: Number},
        bot_uuid: { type: String },
        skill_uuid: { type: String }
    },

    data() {
        return {
            trackByAction: 'code',

            id: 0,
            parents_id: [],
            childs_id: [],
            position: [],
            action: null,
            description: null,
            message_send: {
                phone: null,
                client_id: null,
                text: null,
                channel_code: null,
                bot_channel_uuid: null,
                provider: null,
                provider_uuid: null,
                product_code: null
            },
            audio: {
                title: null,
                filename: null,
                status: null,
                path: null,
                ext: null,
                uuid: null,
                from_variable: false,
                source_variable: null,
                can_interrupt: false,
                interrupt_block_id: null
            },
            record: {
                async_action: false,
                variable_name: null,
                max_silence_begin: null,
                max_silence_end: null
            },
            stt_params: {
                async_action: false,
                grammar: null,
                language: null,
                provider: null,
                provider_uuid: null,
                product_code: 'stt',
                source_variable: null,
                variable_name: null,
                max_silence_begin: null,
                max_silence_end: null,
                delayed: null,
                delayed_time: null,
                literature: null
            },
            tts_params: {
                ssml: null,
                id: null,
                speed: 1,
                emotion: null,
                language: null,
                provider: null,
                provider_uuid: null,
                product_code: 'tts',
                variable_name: null
            },
            digital_input_params: {
                digitals: null
            },
            text: null,
            intent: {
                variable: null,
                words_equal: [],
                words_in: [],
                words_not_in: [],
                action: null
            },
            condition: {
                operation: null,
                action: null
            },
            http_request_params: {
                url: null,
                method: null,
                header: null,
                variables: null
            },
            ai_request_params: {
                id: null,
                provider: null,
                provider_uuid: null,
                product_code: 'ai_request',
                system_message: null,
                user_message: null,
                clear_context: false,
                model: null,
                variable_name: null,
                temperature: 0.5,
                max_tokens: 4000,
                stream: false,
                fl_knowledge: false,
                knowledge_uuid: null,
                knowledge_request: null,
                fl_request_classifier: false,
                classifier_request: null
            },
            event_wait_params: {
                operation: null
            },
            path: {
              priority: null,
              parentId: null,
              childId: null
            },
            voicemail_detection_params: {
                dictionary_uuid: null,
                async_action: null,
                product_code: null
            },
            call_redirect_params: {
                phone_number: null,
                play_notify: false
            },
            call: {
                timeout: 0
            },
            set_variables: null,

            next_action: null,

            initAction: [],
            actions_options: [],

            show_audio_play: false,
            show_speech_synthesis: false,
            show_audio_transcription: false,
            show_set_variables: false,
            show_message_send: false,
            show_http_request: false,
            show_condition: false,
            show_intent: false,
            show_call: false,
            show_audio_record: false,
            show_end_call: false,
            show_voicemail_detection: false,
            show_variable_name_item: false,
            show_ai_request: false,
            show_event_wait: false,
            show_call_redirect: false,
            show_goto: false,
            show_digital_input: false,

            attachments: new Map(),
        }
    },

    watch: {
        initAction: {
            immediate: true,
            handler(values) {
                this.action = this.actions_options.filter(x => values.includes(x[this.trackByAction]));
                this.action = this.action[0];
            }
        },

        action: {
            immediate: true,
            handler(values) {

                this.show_audio_play = false;
                this.show_speech_synthesis = false;
                this.show_audio_transcription = false;
                this.show_digital_input = false;
                this.show_set_variables = false;
                this.show_http_request = false;
                this.show_condition = false;
                this.show_intent = false;
                this.show_call = false;
                this.show_audio_record = false;
                this.show_end_call = false;
                this.show_ai_request = false;
                this.show_message_send = false;
                this.show_event_wait = false;
                this.show_call_redirect = false;
                this.show_goto = false;

                if(this.action && this.action.code) {

                    // Проиграть аудио
                    if (this.action.code === 'audio_play') {
                        this.show_audio_play = true;
                    }

                    // Синтезировать голос
                    if (this.action.code === 'speech_synthesis') {
                        this.show_speech_synthesis = true;
                    }

                    // Распознать голос
                    if (this.action.code === 'audio_transcription') {
                        this.show_audio_transcription = true;
                    }

                    // Присвоить переменную
                    if (this.action.code === 'set_variables') {
                        this.show_set_variables = true;
                    }

                    // Выполнить HTTP-запрос
                    if (this.action.code === 'http_request') {
                        this.show_http_request = true;
                    }

                    // Условие
                    if (this.action.code === 'condition') {
                        this.show_condition = true;
                    }

                    // Интент
                    if (this.action.code === 'intent') {
                        this.show_intent = true;
                    }

                    // Переход к блоку
                    if (this.action.code === 'goto') {
                        this.show_goto = true;
                    }

                    // Позвонить
                    if (this.action.code === 'call') {
                        this.show_call = true;
                    }

                    // Записать разговор
                    if (this.action.code === 'audio_record') {
                        this.show_audio_record = true;
                    }

                    // Завершить звонок
                    if (this.action.code === 'end_call') {
                        this.show_end_call = true;
                    }

                    // Запрос в AI
                    if (this.action.code === 'ai_request') {
                        this.show_ai_request = true;
                    }

                    // Ожидать событие
                    if (this.action.code === 'event_wait') {
                        this.show_event_wait = true;
                    }

                    // Отправить сообщение в мессенжер
                    if (this.action.code === 'message_send') {
                        this.show_message_send = true;
                    }

                    // Переадресация звонка
                    if(this.action.code === 'call_redirect'){
                        this.show_call_redirect = true;
                    }

                    // Цифровой ввод
                    if(this.action.code === 'digital_input'){
                        this.show_digital_input = true;
                    }
                }
            }
        },
    },

    computed: {
        // blockOptions: {
        //   get() {
        //     return this.actions_options.filter(option => {
        //       if (this.type === 'default') {
        //         return (option.code !== 'condition' && option.code !== 'intent')
        //       }
        //       return (option.code === 'condition' || option.code === 'intent')
        //     })
        //   }
        // },

        attachments_files: {
            get: function () {
                return this.attachments
            },
            set: function (value) {
                this.attachments = value;
            }
        },

        actions_list_data(){
            return this.$store.getters['actions/GET_ACTIONS_LIST_DATA'];
        },
    },

    async mounted() {
      const defaultPatchAction = {code: 'default', id: 0, name: 'Переход', uuid: ''}

      await this.$store.dispatch('actions/FETCH_ACTIONS_LIST', {});
        this.actions_options = this.actions_list_data.filter(option => {
          if (this.type === 'default')
            // return (option.code !== 'condition' && option.code !== 'intent')
            return (option.code !== 'condition')
          return (option.code === 'condition' || option.code === 'intent')
        });

        if (this.type !== 'default'){
          this.actions_options.push(defaultPatchAction)
        }

        if (this.type === 'path')
          this.action = defaultPatchAction

        if (this.targetPath){
          this.path.priority = this.targetPath.priority
          this.path.parentId = this.blockId
          this.path.childId = this.targetPath.id
        }

        this.id = this.blockId

        if (!this.params) return

        this.action = this.params.action ? this.params.action : 'default';
        if(this.action !== null){
            this.initAction = [this.action]
        }
        this.next_action = this.params.next_action ? this.params.next_action : null;
        this.description = this.params.description ? this.params.description : null;
        this.parents_id = this.params.parents_id ? this.params.parents_id : null;

        this.voicemail_detection_params = {
            async_action: this.params.voicemail_detection_params && this.params.voicemail_detection_params.async_action ? this.params.voicemail_detection_params.async_action : null,
            dictionary_uuid: this.params.voicemail_detection_params && this.params.voicemail_detection_params.dictionary_uuid ? this.params.voicemail_detection_params.dictionary_uuid : null,
            product_code: this.params.voicemail_detection_params && this.params.voicemail_detection_params.product_code ? this.params.voicemail_detection_params.product_code : 'voicemail_detection',
        }

        this.message_send = {
            phone: this.params.message_send && this.params.message_send.phone ? this.params.message_send.phone : null,
            client_id: this.params.message_send && this.params.message_send.client_id ? this.params.message_send.client_id : null,
            text: this.params.message_send && this.params.message_send.text ? this.params.message_send.text : null,
            bot_channel_uuid: this.params.message_send && this.params.message_send.bot_channel_uuid ? this.params.message_send.bot_channel_uuid : null,
            channel_code: this.params.message_send && this.params.message_send.channel_code ? this.params.message_send.channel_code : null,
            provider: this.params.message_send && this.params.message_send.provider ? this.params.message_send.provider : null,
            provider_uuid: this.params.message_send && this.params.message_send.provider_uuid ? this.params.message_send.provider_uuid : null,
            product_code: this.params.message_send && this.params.message_send.product_code ? this.params.message_send.product_code : null
        }

        this.audio = {
            title: this.params.audio.title ? this.params.audio.title : null,
            filename: this.params.audio.filename ? this.params.audio.filename : null,
            status: this.params.audio.status ? this.params.audio.status : null,
            path: this.params.audio.path ? this.params.audio.path : null,
            ext: this.params.audio.ext ? this.params.audio.ext : null,
            uuid: this.params.audio.uuid ? this.params.audio.uuid : null,
            from_variable: this.params.audio.from_variable ? this.params.audio.from_variable : false,
            source_variable: this.params.audio.source_variable ? this.params.audio.source_variable : null,
            can_interrupt: this.params.audio.can_interrupt ? this.params.audio.can_interrupt : false,
            interrupt_block_id: this.params.audio.interrupt_block_id ? this.params.audio.interrupt_block_id : null
        }

        this.record = {
            async_action: this.params.record && this.params.record.async_action ? this.params.record.async_action : null,
            max_silence_begin: this.params.record && this.params.record.max_silence_begin ? this.params.record.max_silence_begin : null,
            max_silence_end: this.params.record && this.params.record.max_silence_end ? this.params.record.max_silence_end : null,
            variable_name: this.params.record && this.params.record.variable_name ? this.params.record.variable_name : null,
            max_duration: this.params.record.max_duration ? this.params.record.max_duration : 0,
        }

        let attachments = new Map();
        if(this.audio.filename !== null){
            attachments.set(this.audio.uuid, {
                'title'    : this.audio.title,
                'filename' : this.audio.filename,
                'status'   : this.audio.status,
                'path'     : this.audio.path,
                'ext'      : this.audio.ext,
                'uuid'     : this.audio.uuid
            })
            this.attachments_files = attachments;
        }

        this.stt_params = {
            grammar: this.params.stt_params.grammar ? this.params.stt_params.grammar : null,
            language: this.params.stt_params.language ? this.params.stt_params.language : null,
            provider: this.params.stt_params.provider ? this.params.stt_params.provider : null,
            product_code: this.params.stt_params.product_code && this.params.stt_params.product_code !== '' ? this.params.stt_params.product_code : this.stt_params.product_code,
            variable_name: this.params.stt_params.variable_name ? this.params.stt_params.variable_name : null,
            source_variable: this.params.stt_params.source_variable ? this.params.stt_params.source_variable : null,
            max_silence_begin: this.params.stt_params.max_silence_begin ? this.params.stt_params.max_silence_begin : null,
            max_silence_end: this.params.stt_params.max_silence_end ? this.params.stt_params.max_silence_end : null,            
            async_action: this.params.stt_params.async_action ? this.params.stt_params.async_action : null,
            delayed: this.params.stt_params && this.params.stt_params.delayed ? this.params.stt_params.delayed : null,
            delayed_time: this.params.stt_params && this.params.stt_params.delayed_time ? this.params.stt_params.delayed_time : 0,
            literature: this.params.stt_params.literature ? this.params.stt_params.literature : null,            
        }

        this.tts_params = {
            ssml: this.params.tts_params.ssml ? this.params.tts_params.ssml : null,
            id: this.params.tts_params.id ? this.params.tts_params.id : null,
            speed: this.params.tts_params.speed ? this.params.tts_params.speed : 1,
            emotion: this.params.tts_params.emotion ? this.params.tts_params.emotion : null,
            language: this.params.tts_params.language ? this.params.tts_params.language : null,
            provider: this.params.tts_params.provider ? this.params.tts_params.provider : null,
            product_code: this.params.tts_params.product_code && this.params.tts_params.product_code !== '' ? this.params.tts_params.product_code : this.tts_params.product_code,
            variable_name: this.params.tts_params.variable_name ? this.params.tts_params.variable_name : null,
        }

        this.digital_input_params = {
            digitals: this.params.digital_input_params && this.params.digital_input_params.digitals ? this.params.digital_input_params.digitals : null,
        }

        this.text = this.params.text ? this.params.text : null;

        this.intent = {
            variable: this.params.intent.variable ? this.params.intent.variable : null,
            words_equal: this.params.intent.words_equal ? this.params.intent.words_equal : [],
            words_in: this.params.intent.words_in ? this.params.intent.words_in : [],
            words_not_in: this.params.intent.words_not_in ? this.params.intent.words_not_in : [],
            action: this.params.intent.action ? this.params.intent.action : null
        }

        this.call = {
            timeout: this.params.call && this.params.call.timeout ? this.params.call.timeout : 0
        }

        this.http_request_params = {
            url: this.params.http_request_params.url ? this.params.http_request_params.url : null,
            method: this.params.http_request_params.method ? this.params.http_request_params.method : null,
            header: this.params.http_request_params.header ? this.params.http_request_params.header : null,
            data: this.params.http_request_params.data ? this.params.http_request_params.data : null,
            variables: this.params.http_request_params.variables ? this.params.http_request_params.variables : null,
            timeout: this.params.http_request_params.timeout ? this.params.http_request_params.timeout : null,
            wait_response: this.params.http_request_params.wait_response ? this.params.http_request_params.wait_response : null,
        }

        this.ai_request_params = {
            id: this.params.ai_request_params && this.params.ai_request_params.id ? this.params.ai_request_params.id : null,
            provider: this.params.ai_request_params && this.params.ai_request_params.provider ? this.params.ai_request_params.provider : null,
            product_code: this.params.ai_request_params && this.params.ai_request_params.product_code && this.params.ai_request_params.product_code !== '' ? this.params.ai_request_params.product_code : this.ai_request_params.product_code,
            provider_uuid: this.params.ai_request_params && this.params.ai_request_params.provider_uuid ? this.params.ai_request_params.provider_uuid : null,
            system_message: this.params.ai_request_params && this.params.ai_request_params.system_message ? this.params.ai_request_params.system_message : null,
            user_message: this.params.ai_request_params && this.params.ai_request_params.user_message ? this.params.ai_request_params.user_message : null,
            variable_name: this.params.ai_request_params && this.params.ai_request_params.variable_name ? this.params.ai_request_params.variable_name : null,
            model: this.params.ai_request_params && this.params.ai_request_params.model ? this.params.ai_request_params.model : null,
            clear_context: this.params.ai_request_params && this.params.ai_request_params.clear_context ? this.params.ai_request_params.clear_context : null,
            temperature: this.params.ai_request_params && this.params.ai_request_params.temperature ? this.params.ai_request_params.temperature : this.ai_request_params.temperature,
            max_tokens: this.params.ai_request_params && this.params.ai_request_params.max_tokens ? this.params.ai_request_params.max_tokens : this.ai_request_params.max_tokens,
            stream: this.params.ai_request_params && this.params.ai_request_params.stream ? this.params.ai_request_params.stream : null,
            fl_knowledge: this.params.ai_request_params && this.params.ai_request_params.fl_knowledge ? this.params.ai_request_params.fl_knowledge : null,
            knowledge_uuid: this.params.ai_request_params && this.params.ai_request_params.knowledge_uuid ? this.params.ai_request_params.knowledge_uuid : null,
            knowledge_request: this.params.ai_request_params && this.params.ai_request_params.knowledge_request ? this.params.ai_request_params.knowledge_request : null,
            fl_request_classifier: this.params.ai_request_params && this.params.ai_request_params.fl_request_classifier ? this.params.ai_request_params.fl_request_classifier : null,
            classifier_request: this.params.ai_request_params && this.params.ai_request_params.classifier_request ? this.params.ai_request_params.classifier_request : null,
            fl_answer_classifier: this.params.ai_request_params && this.params.ai_request_params.fl_answer_classifier ? this.params.ai_request_params.fl_answer_classifier : null,
            classifier_answer: this.params.ai_request_params && this.params.ai_request_params.classifier_answer ? this.params.ai_request_params.classifier_answer : null,
            fl_summarizing: this.params.ai_request_params && this.params.ai_request_params.fl_summarizing ? this.params.ai_request_params.fl_summarizing : null,
            summarizing_request: this.params.ai_request_params && this.params.ai_request_params.summarizing_request ? this.params.ai_request_params.summarizing_request : null
        }
        
        this.event_wait_params = {
            operation: this.params.event_wait_params && this.params.event_wait_params.operation ? this.params.event_wait_params.operation : null
        }

        this.call_redirect_params = {
            phone_number: this.params.call_redirect_params && this.params.call_redirect_params.phone_number ? this.params.call_redirect_params.phone_number : null,
            play_notify: this.params.call_redirect_params && this.params.call_redirect_params.play_notify ? this.params.call_redirect_params.play_notify : false            
        }

        this.condition = {
            operation: this.params.condition.operation ? this.params.condition.operation : null,
            action: this.params.condition.action ? this.params.condition.action : null
        }

        this.set_variables = this.params.set_variables ? this.params.set_variables : null;
    },

    methods: {

        async deleteItem(index){
            this.$parent.$parent.$parent.$parent.$parent.deleteBlock(index);
            return false;
        },

        getData(){
            if(this.attachments.size > 0){
                let attachments = [];
                this.attachments.forEach(el => {
                    attachments.push(el);
                })
                this.audio.title    = attachments[0].title;
                this.audio.filename = attachments[0].filename;
                this.audio.status   = attachments[0].status;
                this.audio.path     = attachments[0].path;
                this.audio.ext      = attachments[0].ext;
                this.audio.uuid     = attachments[0].uuid;
            } else {
                this.audio.title    = null;
                this.audio.filename = null;
                this.audio.status   = null;
                this.audio.path     = null;
                this.audio.ext      = null;
                this.audio.uuid     = null;
            }

            if(!this.audio.from_variable){
                this.audio.variable_name = null;
            }

            return {
                "id": this.id,
                "parents_id": this.parents_id,
                "description": this.description,
                "action": this.action && this.action.code ? this.action.code : null,
                "message_send": this.message_send,
                "audio": this.audio,
                "record": this.record,
                "stt_params": this.stt_params,
                "tts_params": this.tts_params,
                "digital_input_params": this.digital_input_params,
                "voicemail_detection_params": this.voicemail_detection_params,
                "text": this.text,
                "intent": this.intent,
                "condition": this.condition,
                "call": this.call,
                "http_request_params": this.http_request_params,
                "ai_request_params": this.ai_request_params,
                'event_wait_params': this.event_wait_params,
                "set_variables": this.set_variables,
                "call_redirect_params": this.call_redirect_params,
                "path": this.path.priority && this.path || null,
                "next_action": this.next_action
            }
        }
    }
}
</script>

<template>
    <div class="draggable" style="border: none; max-width: 900px; margin: 20px; margin-left: 0px; margin-right: 0px; border-top: 1px solid rgba(0, 0, 0, 0.125) !important">
        <b-form-group
            style="margin-top: 25px"
            label="Действие"
            :label-for="'block_' + id"
        >
            <multiselect
                :id="'block_' + id"
                :track-by="trackByAction"
                v-model="action"
                v-if="actions_options"
                :options="actions_options"
                placeholder="Выберите из списка"
                selectLabel="Нажмите, чтобы выбрать"
                deselectLabel="Нажмите, снять выделение"
                label="name"
            />
        </b-form-group>

        <FormAudioPlay v-if="show_audio_play" />
        <FormAudioRecord v-if="show_audio_record" />
        <FormSpeechSynthesis v-if="show_speech_synthesis" />
        <FormAudioTranscription v-if="show_audio_transcription" />
        <FormSetVariables v-if="show_set_variables" />
        <FormMessageSend v-if="show_message_send" />
        <FormHTTPRequest v-if="show_http_request" />
        <FormAIRequest v-if="show_ai_request" />
        <FormEventWait v-if="show_event_wait" />
        <FormCondition v-if="show_condition" />
        <FormIntent v-if="show_intent" />
        <FormGoTo v-if="show_goto" />
        <FormCallRedirect v-if="show_call_redirect" />
        <FormCall v-if="show_call" />
        <FormDigitalInput v-if="show_digital_input" />        

        <div class="row">
            <div class="col-sm-12">
                <b-form-group
                    v-if="action !== 'default'"
                    label="Комментарий к блоку"
                    :label-for="'description_' + id"
                >
                    <b-form-input
                        :id="'description_' + id"
                        v-model="description"
                    />
                </b-form-group>
                <b-form-group
                  v-if="type === 'path' || type === 'condition'"
                  label="Приоритет"
                  label-for="priority"
                  >
                    <b-form-input id="priority" v-model="path.priority" type="number"/>
                </b-form-group>
            </div>
        </div>
        <div class="row" style="margin-top: 20px">
            <div class="col-sm-12">
                <button type="submit" class="btn btn-primary" style="margin-right: 7px" @click="$emit('save', getData())">Сохранить</button>
                <button class="btn btn-light" @click="$emit('close')">Отменить</button>                
            </div>
        </div>
    </div>
</template>

<style>
    .draggable h5 {
        cursor: grab;
    }
</style>